// components/MenuLink/MenuLink.tsx
'use client';

import Link, { type LinkProps } from 'next/link';
import { useParams } from 'next/navigation';
import React from 'react';

type Href = LinkProps['href'];

type MenuLinkProps = Omit<React.ComponentProps<typeof Link>, 'href' | 'locale'> & {
    href: Href;
};

const MenuLink = React.forwardRef<HTMLAnchorElement, MenuLinkProps>(
    ({ href, ...props }, ref) => {
        const { locale } = useParams() as { locale: string };

        const path = typeof href === 'string' ? href : String(href?.pathname ?? '');
        const isExternal =
            path.startsWith('http') || path.startsWith('mailto:') || path.startsWith('tel:') || path.startsWith('#');

        // External or anchor: don't force locale
        if (isExternal) return <Link ref={ref} href={href} {...props} />;

        return <Link ref={ref} href={href} locale={locale} {...props} />;
    }
);

MenuLink.displayName = 'MenuLink';
export default MenuLink;
